import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  HostBinding,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from "@angular/core";
import {AbstractControl, FormBuilder, FormControl, Validators} from "@angular/forms";
import {IModel} from "../../../../../shared/view-model/imodel.interface";
import {isUndefined} from "util";
import {SessionActions} from "../../../../../shared/actions/session.actions";
import {AbstractVisbosControl} from "../abstract-visbos-control";
import {Subscription} from "rxjs/Subscription";

@Component({
  selector: 'vb-generic-selection-input',
  templateUrl: './generic-selection-input.component.html',
  styleUrls: ['./generic-selection-input.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => GenericSelectionInputComponent)}]
})
export class GenericSelectionInputComponent extends AbstractVisbosControl<IModel, FormControl> implements OnInit, OnChanges {

  @HostBinding('class.input-group-sm')
  get inputGroupSmBinding() {
    return this.addable;
  }

  @HostBinding('class.input-group')
  get inputGroupBinding() {
    return this.addable;
  }

  @Input()
  styleClass: string = 'input-sm'; //TODO: Remove

  @Input()
  sort = true;

  @Input()
  sortFunction = (a: IModel, b: IModel) => {
    const aLabel = a.label ? a.label : '';
    return aLabel.localeCompare(b.label);
  }

  private _isDisabled: boolean = false;

  get isDisabled(): boolean {
    return this._isDisabled;
  }

  @Input()
  set isDisabled(value: boolean) {
    this._isDisabled = value;
    if (this.control) {
      if (value === true) {
        this.control.disable();
      } else {
        this.control.enable();
      }
    }
  }

  @Input()
  itemLabel: (item: IModel) => string = (item: IModel) => item.label;

  @Input()
  itemId: (item: IModel) => string = (item: IModel) => item.cuid;

  @Input()
  label: string;

  @Input()
  inputId: string;

  @Input()
  addable: boolean = false;

  @Input()
  optional: boolean;

  @Input()
  items: IModel[] = [];

  get selectedItem(): IModel {
    return this.item;
  }

  @Input()
  set selectedItem(value: IModel) {
    this.item = value;
  }

  @Input()
  set ctrl(ctrl: FormControl) {
    this.control = ctrl;
  }

  get ctrl(): FormControl {
    return this.control;
  }

  private controlSub: Subscription;

  @Output()
  itemSelected: EventEmitter<IModel> = new EventEmitter<IModel>(); // User selection

  @Output()
  itemDeselected: EventEmitter<IModel> = new EventEmitter<IModel>();

  @Output()
  itemChanged: EventEmitter<IModel | null> = new EventEmitter(); // Automatic changes, too

  @Output()
  addClicked: EventEmitter<any> = new EventEmitter<any>();

  constructor(fb: FormBuilder, cd: ChangeDetectorRef, sessionActions: SessionActions) {
    super(fb, cd, sessionActions);
  }

  ngOnInit() {
    super.ngOnInit();

    // Subscription to watch for control changes
    this.watchOptionalControl();
    let ct = this.controlChange.subscribe((ctrl: AbstractControl) => {
      this.watchOptionalControl();
    });

    this.dataSubscriptions.push(ct);
  }


  buildControlContent(values ?: IModel, ...params): FormControl {
    return this.fb.control(null);
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);

    if (changes.items) {
      if (this.sort && this.items && this.items.length) {
        const it = [...this.items];
        this.items = it.sort(this.sortFunction);
      }
      this.watchItemsChange();
    }

  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.controlSub) {
      this.controlSub.unsubscribe();
    }
  }

  private watchItemsChange() {
    if (this.items && this.items.length == 1 && !this.optional) {
      this.control.setValue(this.items[0].cuid);
      this.onItemSelected(this.items[0]);
    }
  }

  private watchOptionalControl() {
    // Set optional to false, if control validator is required
    if (isUndefined(this.optional) && this.control && this.control.validator == Validators.required) {
      this.optional = false;
    }

    if (isUndefined(this.optional) && this.control && !this.control.validator) {
      //TODO: Buggy implementation as it is not clear, if the control is required or not...
      this.optional = true;
    }

    if (this.control.validator == Validators.compose) {
      console.warn("Cannot automatically determine required state for form control with composed validators, please set optional argument manually!", [this]);
    }

    if (this.controlSub) {
      this.controlSub.unsubscribe();
    }

    this.controlSub = this.control.valueChanges.subscribe((val: any) => {
      if (this.items && val) {
        let i = val ? this.items.find(it => it.cuid === val) : null;
        this.onItemSelected(i);
      }
      if (!val) {
        this.onItemDeselected();
      }
    });
  }

  onAddClicked() {
    this.addClicked.emit();
  }

  onItemSelected(item: IModel) {
    this.selectedItem = item;
    setTimeout(() => {
      this.itemChanged.emit(item);
      if (this.control.dirty) {
        this.itemSelected.emit(item);
      }
    });

  }

  onItemDeselectClicked() {
    this.control.setValue(null);
    this.control.markAsDirty();
    this.onItemDeselected();
  }

  onItemDeselected() {
    let oldItem = this.selectedItem;
    this.selectedItem = null;
    setTimeout(() => {
      this.itemChanged.emit(null);
      if (this.control.dirty) {
        this.itemDeselected.emit(oldItem);
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/ui/forms/generic-selection-input/generic-selection-input.component.ts